import React from "react";
import Partner from "../../types/Partner";
import { InfoWindow } from "react-google-maps";
import {
  Label,
  Name,
  Address,
  InfoWindowWrap
} from "./styles/infoWindowStyles";
import { createPhoneNumbersList, createEmailsList } from "../../utils/mapUtils";
import WebsiteLink from "../links/WebsiteLink";

interface InfoWindowComponentProps {
  partner: Partner;
}

const InfoWindowComponent = (props: InfoWindowComponentProps) => {
  const { partner } = props;

  const phoneNumbersList = createPhoneNumbersList(partner.phones);
  const emailsList = createEmailsList(partner.emails);

  return (
    <InfoWindow>
      <InfoWindowWrap>
        <Label>Ośrodek Współpracujący</Label>
        <Name>{partner.name}</Name>
        <Address>
          {partner.address}
          <br />
          {partner.post_code} {partner.city}
        </Address>
        {phoneNumbersList && phoneNumbersList.map(phoneNumber => phoneNumber)}
        {emailsList && emailsList.map(email => email)}
        {partner.website && <WebsiteLink website={partner.website} />}
      </InfoWindowWrap>
    </InfoWindow>
  );
};

export default InfoWindowComponent;
